const snow = ['IMG_0112.JPG',
'IMG_0118.JPG',
'IMG_0277.JPG',
'IMG_0278.JPG',
'IMG_0281.JPG',
'IMG_0283.JPG',
'IMG_0292.JPG',
'IMG_0295.JPG',
'IMG_0303.JPG',
'IMG_0306.JPG',
'IMG_0307.JPG',
'IMG_0309.JPG',
'IMG_0310.JPG',
'IMG_0312.JPG',
'IMG_0313.JPG',
'IMG_0318.JPG',
'IMG_0321.JPG',
'IMG_0322.JPG',
'IMG_0323.JPG',
'IMG_0325.JPG',
'IMG_0333.JPG',
'IMG_0335.JPG',
'IMG_0338.JPG',
'IMG_0339.JPG',
'IMG_0358.JPG',
'IMG_0364.JPG',
'IMG_0366.JPG',
'IMG_0367.JPG',
'IMG_0370.JPG',
'IMG_0371.JPG',
'IMG_0372.JPG',
'IMG_0409.JPG',
'IMG_1664.JPG',
'IMG_1665.JPG',
'IMG_1671.JPG',
'IMG_1678.JPG',
'IMG_1681.JPG',
'IMG_1720.JPG',
'IMG_1723.JPG',
'IMG_1865.JPG',
'IMG_3464.JPG',
'IMG_3557.JPG',
'IMG_3568.JPG',
'IMG_3571.JPG',
'IMG_3576.JPG',
'IMG_3577.JPG',
'IMG_3645.JPG',
'IMG_3985.JPG',
'IMG_3987.JPG',
'REBELXS_IMG_0503.JPG',
'REBELXS_IMG_0510.JPG',
'REBELXS_IMG_0511.JPG',
'REBELXS_IMG_0512.JPG',
'REBELXS_IMG_0519.JPG',
'REBELXS_IMG_0525.JPG',
'REBELXS_IMG_0530.JPG',
'REBELXS_IMG_0534.JPG',
'REBELXS_IMG_0535.JPG',
'REBELXS_IMG_0539.JPG',
'REBELXS_IMG_0548.JPG',
'REBELXS_IMG_0550.JPG',
'REBELXS_IMG_0558.JPG',
'REBELXS_IMG_0565.JPG',
'REBELXS_IMG_0570.JPG',
'REBELXS_IMG_0576.JPG',
'REBELXS_IMG_0588.JPG',
'REBELXS_IMG_0589.JPG',
'REBELXS_IMG_0593.JPG',
'REBELXS_IMG_0595.JPG',
'REBELXS_IMG_0599.JPG',
'REBELXS_IMG_0601.JPG',
'REBELXS_IMG_0604.JPG',
'REBELXS_IMG_0618.JPG',
'REBELXS_IMG_0622.JPG',
'REBELXS_IMG_0623.JPG',
'REBELXS_IMG_0624.JPG',
'REBELXS_IMG_0635.JPG',
'REBELXS_IMG_0642.JPG',
'REBELXS_IMG_0654.JPG',
'REBELXS_IMG_0655.JPG',
'REBELXS_IMG_0672.JPG',
'REBELXS_IMG_0674.JPG',
'REBELXS_IMG_2492.JPG',
'REBELXS_IMG_2496.JPG',
'REBELXS_IMG_2500.JPG',
'REBELXS_IMG_2509.JPG',
'REBELXS_IMG_2514.JPG',
'REBELXS_IMG_2525.JPG',
'REBELXS_IMG_2662.JPG',
'REBELXS_IMG_2669.JPG',
'REBELXS_IMG_2671.JPG',
'REBELXS_IMG_2744.JPG',
'REBELXS_IMG_2745.JPG',
'REBELXS_IMG_2746.JPG',
'STA_1705.JPG',
'IPHONE2G_IMG_0086.JPG',
'IPHONE2G_IMG_0266.JPG'];

export default snow;